import { CSSProperties, PropsWithChildren } from "react";

type Props = PropsWithChildren<{
  width?: CSSProperties["width"];
  maxWidth?: CSSProperties["maxWidth"];
}>;

export default function Table({ children, width, maxWidth }: Props) {
  const styles: CSSProperties = {
    margin: "0 auto",
    width: width || "100%",
    maxWidth: maxWidth,
  };

  return <table style={styles}>{children}</table>;
}
